// extracted by mini-css-extract-plugin
module.exports =  {"titles":"ring-tabs-titles","unit":"var(--ring-unit)","tabs":"PipelineRunPage__tabs--Rr","tabContent":"PipelineRunPage__tabContent--Ma","tab":"PipelineRunPage__tab--I1"};